import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import ManageReviewsTable from "./ManageReviewsTable";
import { Message } from "primereact/message";
import { SplitButton } from "primereact/splitbutton";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { getReviews } from "../../store/AsyncMethods/ReviewsMethod";

export default function ManageReviewsMain() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { reviews, loading } = useSelector((state) => state.ReviewReducers);

  useEffect(() => {
    dispatch(getReviews());
  }, [dispatch]);

 

  return (
    <div className="p-4 bg-gray-50 min-h-screen">
      <div className="flex justify-between items-center mb-4">
        <div>
            <p className="text-sm text-gray-500">Home &gt; Manage Reviews</p>
        </div>
        <div className="flex items-center gap-2">
          
          <Button
            label="Add Review"
            icon="pi pi-plus"
            className="p-primary-btn"
            onClick={() => navigate("/add-review")}
          />
        </div>
      </div>
      
      <div className="my-4">
        <ManageReviewsTable reviews={reviews} loading={loading} />
      </div>
    </div>
  );
} 